import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NavigationService } from '@modules/navigation/services';
import { SecureStorageService } from '../../../../app/services/secure-storage.service';

@Component({
    selector: 'sb-top-nav',
    templateUrl: './top-nav.component.html',
    styleUrls: ['top-nav.component.scss'],
    standalone: false
})
export class TopNavComponent implements OnInit {
    @Input() rtl = false;
    @Input() impersination!: string;

    company: any = "Smart-View Utilities";
    constructor(private navigationService: NavigationService , private secureStorage:SecureStorageService) {}
    async ngOnInit() {
        let company:any = localStorage.getItem('company')
        let companyName =  await this.secureStorage.getItem('companyName');
        if(companyName && companyName != "" && companyName != null && companyName != "null"){
            this.company = companyName
        }else if(company == 'eykon' && (companyName == "" || companyName == null || companyName == "null")){
            this.company = 'Eykon Utilities'
        }else if(company == 'landis' && (companyName == "" || companyName == null || companyName == "null")){
            this.company = 'Landis + Gyr Utilities'
        }  
    }
   toggleSideNav() {
    this.navigationService.toggleSideNav();
   }
}
